import React from 'react';

export default function Arrow({className=''}) {
  return <svg className={`arrow ${className}`.trim()} viewBox="0 0 20 20" aria-hidden="true" focusable="false">
    <path d="M5 15 15 5M7 5h8v8" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>;
}
